<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <span
              v-on="on"
              class="d-flex flex-1 align-center sub-header1 bold text-tcdc-grey1"
      >
        {{localeChange(value)}}
      </span>
    </template>
    <v-date-picker
      color="#2e8037"
      v-model="date"
      :show-current="false"
      type="month"
      @change="onChange"
      :locale="lang"
      @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
  import { mapState } from 'vuex';
  import moment from "moment";
export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data: () => ({
    date: new Date().toISOString().substr(0, 7),
    selectedDate: new Date().getMonth() + 1,
    menu: false,
    monthList: [
      "",
      "JANUARY",
      "FEBUARY",
      "MARCH",
      "APRIL",
      "MAY",
      "JUNE",
      "JULY",
      "AUGUST",
      "SEPTEMBER",
      "OCTOBER",
      "NOVEMBER",
      "DECEMBER"
    ]
  }),
  watch: {
    value(val) {
      const year = val.split(" ")[0];
      const monthText = val.split(" ")[1];
      const month = this.monthList.findIndex(x => x === monthText);
      this.date = `${year}-${month}`;
    }
    // menu(val) {
    //   val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    // }
  },
  methods: {
    onChange(date) {
      this.date = date;
      this.$emit("onPress", date);
    },
    localeChange(val) {
      if (this.lang === 'th') {
        let x = val.split(' ');
        let year = parseInt(x[0]) + 543;
        let month = moment().locale('th').month(x[1]).format('MMMM');
        return year + ' ' + month;
      } else {
        return val;
      }
    }
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    })
  }
};
</script>

<style>
</style>
